import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[acsStopPropagation]'
})
export class StopPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation();
  }
}
